













































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import { HeaderWidthItem } from "@/types";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { getDefaultMonth } from "@/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    LoadingDialog
  }
})
export default class BillingList extends mixins(AxiosMixin) {
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  //=================================================================
  // 請求一覧
  //=================================================================
  //項目
  private headerItems: HeaderWidthItem[] = [
    {
      value: "kind",
      text: "",
      width: "70px"
    },
    {
      value: "total_sales",
      text: "売上合計",
      width: "96px"
    },
    {
      value: "insurance_claim",
      text: "保険請求",
      width: "96px"
    },
    {
      value: "public_funding_request",
      text: "介護公費請求",
      width: "96px"
    },
    {
      value: "user_request_subtotal",
      text: "利用者請求（小計）",
      width: "120px"
    },
    {
      value: "user_request_insurance",
      text: "利用者請求（保険内）",
      width: "120px"
    },
    {
      value: "user_request_overinsurance",
      text: "利用者請求（保険超過）",
      width: "120px"
    },
    {
      value: "adjust_amount",
      text: "調整",
      width: "48px"
    }
  ];

  //データテーブル
  private tableItems: object[] = [];

  //=================================================================
  // 対象年月
  //=================================================================
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }

  //=================================================================
  // 検索ボタン
  //=================================================================
  private search() {
    this.postJsonCheck(
      window.base_url + "/api/office/billinglist/get",
      {
        yearmonth: this.yearmonth.replace("-", "")
      },
      res => {
        this.tableItems = res.data.billing;
        this.$router;
      }
    );
  }

  //=================================================================
  // ダウンロードボタン
  //=================================================================
  private download() {
    const param = {
      table_items: this.tableItems
    };

    const fname = `請求一覧_${this.yearmonth}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/billinglist/download",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    const ym = localStorage.getItem("yearmonth");
    this.yearmonth = ym ? String(ym) : getDefaultMonth().substr(0, 7);
    this.search();
  }
}
